import React from 'react';
import styled from 'styled-components';
import { UploadStatus } from '../../types/FileStatuses'
import {
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    LikeOutlined,
    MonitorOutlined,
    SendOutlined,
} from '@ant-design/icons';

const RequestStatusCompleted = styled.div`
    align-items: center;
    border: 1px solid #40A142;
    border-radius: 20px;
    color: #40A142;
    display: flex;
    font-size: 13px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    justify-content: center;
    margin: 5px 9px;
    padding: 5px 10px;
    width: fit-content;
`;
const RequestStatusFailed = styled.div`
    align-items: center;
    border: 1px solid red;
    border-radius: 20px;
    color: red;
    display: flex;
    font-size: 13px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    justify-content: center;
    margin: 5px 9px;
    padding: 5px 10px;
    width: fit-content;
`;
const RequestStatusScanning = styled.div`
    align-items: center;
    border: 1px solid #1998d5;
    border-radius: 20px;
    color: #1998d5;
    display: flex;
    font-size: 13px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    justify-content: center;
    margin: 5px 9px;
    padding: 5px 10px;
    width: fit-content;
`;
const RequestStatusUploading = styled.div`
    align-items: center;
    border: 1px solid #1998d5;
    border-radius: 20px;
    color: #1998d5;
    display: flex;
    font-size: 13px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    justify-content: center;
    margin: 5px 9px;
    padding: 5px 10px;
    width: fit-content;
`;
const RequestStatusRequested = styled.div`
    align-items: center;
    border: 1px solid orange;
    border-radius: 20px;
    color: orange;
    display: flex;
    font-size: 13px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    justify-content: center;
    margin: 5px 9px;
    padding: 5px 10px;
    width: fit-content;
`;

export const CurrentRequestStatusElements: Record<UploadStatus, JSX.Element> = {
        [UploadStatus.Completed]:
            <RequestStatusCompleted>
                <LikeOutlined style={{ marginRight: '5px' }} />
                File Upload Complete
            </RequestStatusCompleted>,
        [UploadStatus.Failed]:
            <RequestStatusFailed>
                <ExclamationCircleOutlined style={{ marginRight: '5px' }} />
                Invalid File
            </RequestStatusFailed>,
        [UploadStatus.Scanning]:
            <RequestStatusScanning>
                <MonitorOutlined style={{ marginRight: '5px' }} />
                Scanning File
            </RequestStatusScanning>,
        [UploadStatus.Uploading]:
            <RequestStatusUploading>
                <CloudUploadOutlined style={{ marginRight: '5px' }} />
                Received | Awaiting Neighbor Upload
            </RequestStatusUploading>,
        [UploadStatus.Requested]:
            <RequestStatusRequested>
                <SendOutlined style={{ marginRight: '5px' }} />
                Request Sent
            </RequestStatusRequested>,
        [UploadStatus.Expired]:
            <RequestStatusFailed>
                <ExclamationCircleOutlined style={{ marginRight: '5px' }} />
                Request Expired
            </RequestStatusFailed>,
    }
